var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FunnelHome',_vm._b({scopedSlots:_vm._u([{key:"collectivity-picker",fn:function(){return [_c('ScPlaceholder',{attrs:{"name":"jss-content","rendering":_vm.rendering}})]},proxy:true}])},'FunnelHome',_vm.funnelData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }